import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock-upgrade';

document.addEventListener('DOMContentLoaded', async () => {
  const nav = document.querySelector('.js-rlx-nav') as HTMLElement;
  const navToggle = document.querySelector('.js-toggle-rlx-nav') as HTMLButtonElement;
  const navDropdown = document.querySelector('.js-rlx-nav-dropdown') as HTMLElement;
  const navLinks = document.querySelectorAll<HTMLAnchorElement>('.rlx-header__nav-link');

  updateNavTabIndexesOnLoad();

  navToggle.addEventListener('click', (e) => {
    e.preventDefault();

    if (navDropdown.classList.contains('open')) {
      navToggle.classList.remove('open');
      navDropdown.classList.remove('open');
      nav.classList.remove('nav-open');
      navDropdown.setAttribute('aria-hidden', 'true');
      clearAllBodyScrollLocks();
      setNavTabIndexes(false);
    } else {
      // .nav-open pins the header to the viewport top (see header.less), so
      // the dropdown opens in place from any scroll position
      navToggle.classList.add('open');
      navDropdown.classList.add('open');
      nav.classList.add('nav-open');
      navDropdown.removeAttribute('aria-hidden');
      disableBodyScroll(navDropdown);
      setNavTabIndexes(true);
    }
  });

  window.addEventListener('resize', () => {
    updateNavTabIndexesOnLoad();

    if (window.innerWidth > 1944) {
      if (nav) {
        navToggle.classList.remove('open');
        navDropdown.classList.remove('open');
        nav.classList.remove('nav-open');
        navDropdown.removeAttribute('aria-hidden');
        clearAllBodyScrollLocks();
      }
    }
  });

  // Check breadcrumbs to see if it has a parent page. If there are only two that means its not a child page

  // Select all elements with the class 'rlx-breadcrumbs__link'
  const breadcrumbLinks = document.querySelectorAll<HTMLAnchorElement>('.rlx-breadcrumbs__link');

  // Convert the NodeList to an array
  const breadcrumbLinkArray = Array.from(breadcrumbLinks);

  // Ensure there is at least one element and remove the first element (ie remove the rolex landing page)
  if (breadcrumbLinkArray.length !== 0) {
    breadcrumbLinkArray.shift();
  }

  navLinks.forEach((link) => {
    // Check if the link's href matches the current URL or its parents
    if (link.href === document.URL) {
      link.classList.add('active');
      return;
    } else if (breadcrumbLinkArray.length) {
      breadcrumbLinkArray.forEach((breadcrumb) => {
        if (link.href === breadcrumb.href) {
          link.classList.add('active');
          return;
        }
      });
    }
  });

  function updateNavTabIndexesOnLoad() {
    const isOpen = navDropdown.classList.contains('open');
    setNavTabIndexes(isOpen);
  }

  function setNavTabIndexes(active: boolean) {
    // If desktop size, always allow tabbing
    if (window.innerWidth >= 1945) {
      navLinks.forEach((link) => link.setAttribute('tabindex', '0'));
      return;
    }

    navLinks.forEach((link) => {
      link.setAttribute('tabindex', active ? '0' : '-1');
    }
    );
  }
});
